// expects a str in the "HH:MM"
function formatTimeTo12Hour(timeToConvert) {
  if (!timeToConvert) return '';
  // Check correct time format and split into components
  let time = timeToConvert
    .toString()
    .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [timeToConvert];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(''); // return adjusted time or original string
}

export default formatTimeTo12Hour;
